export default "__VITE_ASSET__BYtQAWvn__"